// Layer manipulation utility functions
export const moveElementForward = (elements, elementId) => {
  const sortedElements = [...elements].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
  const index = sortedElements.findIndex(el => el.id === elementId);

  if (index === -1 || index === sortedElements.length - 1) return elements;

  const current = sortedElements[index];
  const next = sortedElements[index + 1];

  return elements.map(el => {
    if (el.id === current.id) return { ...el, zIndex: next.zIndex };
    if (el.id === next.id) return { ...el, zIndex: current.zIndex };
    return el;
  });
};

export const moveElementBackward = (elements, elementId) => {
  const sortedElements = [...elements].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
  const index = sortedElements.findIndex(el => el.id === elementId);

  if (index <= 0) return elements;

  const current = sortedElements[index];
  const previous = sortedElements[index - 1];

  return elements.map(el => {
    if (el.id === current.id) return { ...el, zIndex: previous.zIndex };
    if (el.id === previous.id) return { ...el, zIndex: current.zIndex };
    return el;
  });
};

export const moveElementToFront = (elements, elementId) => {
  const sortedElements = [...elements].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
  const maxZIndex = sortedElements.length > 0 ? Math.max(...sortedElements.map(el => el.zIndex || 0)) : 0;

  return elements.map(el => {
    if (el.id === elementId) {
      return { ...el, zIndex: maxZIndex + 1 };
    }
    return el;
  });
};

export const moveElementToBack = (elements, elementId) => {
  return elements.map(el => {
    if (el.id === elementId) {
      // Move this element to z-index 0 (back)
      return { ...el, zIndex: 0 };
    } else {
      // Increment all other elements' z-index by 1 to make room
      return { ...el, zIndex: (el.zIndex || 0) + 1 };
    }
  });
};

// Helper functions for layer queries
export const getSortedElements = (elements) => {
  return [...elements].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
};

export const getElementLayerPosition = (elements, elementId) => {
  const sortedElements = getSortedElements(elements);
  return sortedElements.findIndex(el => el.id === elementId) + 1;
};

export const canMoveForward = (elements, elementId) => {
  const sortedElements = getSortedElements(elements);
  const elementIndex = sortedElements.findIndex(el => el.id === elementId);
  return elementIndex !== -1 && elementIndex < sortedElements.length - 1;
};

export const canMoveBackward = (elements, elementId) => {
  const sortedElements = getSortedElements(elements);
  const elementIndex = sortedElements.findIndex(el => el.id === elementId);
  return elementIndex > 0;
};

export const normalizeZIndices = (elements) => {
  const sorted = [...elements].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
  console.log('Sorted Elements:', sorted);
  return sorted.map((el, i) => ({
    ...el,
    zIndex: i, // reassigns from 0, 1, 2...
  }));
};